import { render, staticRenderFns } from "./Informe.vue?vue&type=template&id=5d372516&scoped=true"
import script from "./Informe.vue?vue&type=script&lang=js"
export * from "./Informe.vue?vue&type=script&lang=js"
import style0 from "./Informe.vue?vue&type=style&index=0&id=5d372516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d372516",
  null
  
)

export default component.exports